import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69e6d4658485e2001497f5cd/cattlebooks/src/app/sign-up-login-screen/components/AuthScreen.tsx");
